<template>
  <v-card class="mx-auto" max-width="400" style="height:100%">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.cover ? item.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>

      <div class="arrow-left-green"></div>
      <div class="label-green">
        Pengimbasan
      </div>
    </div>

    <v-card-title class="blue--text" style="word-break: break-word;">{{ title }} </v-card-title>
    <v-card-subtitle class="black--text">
      <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
      {{ pVal(item, "tanggal_awal") | toD }} -
      {{ pVal(item, "tanggal_akhir") | toD }}
    </v-card-subtitle>
    <v-card-text class="pb-0 text--primary caption">
      <p class="my-0 py-0">
        {{
          $tools.parseIsAfter(this.$tools.parseIsAfter(current_instansi.server_time, current_instansi.wkt_selesai_pengimbasan))
            ? "Pengimbasan Berakhir"
            : "Silakan unggah tautan video Pengimbasan Anda"
        }}
      </p>
      <span v-if="pengimbasan"
        >Video Pengimbasan Anda: <br /><a :href="pengimbasan.url" target="_blank">{{ pengimbasan.url }}</a></span
      >
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="12">
          <m-button
            :disabled="this.$tools.parseIsAfter(current_instansi.server_time, current_instansi.wkt_selesai_pengimbasan)"
            isBlock
            depressed
            color="primary"
            :textButton="$tools.parseIsAfter(current_instansi.server_time, current_instansi.wkt_selesai_pengimbasan) ? 'Pengimbasan Berakhir' : 'Masukkan Tautan'"
            action="unggahUrl"
            @unggahUrl="pengimbasan ? $emit('unggah', pengimbasan) : $emit('unggah')"
          ></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
// @group Global Component
export default {
  inheritAttrs: false,
  props: {
    pengimbasan: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    },
    isdisable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      item: {
        id: 1,
        cover: "https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-akm-tahap-2.jpg",
        tanggal_awal: "2021-04-06 00:00:00",
        tanggal_akhir: "2021-08-07 23:59:59"
      }
    };
  }
};
</script>

<style>
.label-blue {
  background-color: #007bff;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-blue {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid #007bff;
}

.label-red {
  background-color: #e61d4c;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-red {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(170, 0, 0);
}

.label-green {
  background-color: rgb(61, 187, 82);
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-green {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(10, 143, 54);
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 40px;
}
</style>
